export enum LIST_VISIBILITY {
  MIN = 0,
  MAX = 1,
}

export const MAX_NUMBER_OF_ATTEMPTS_TO_SAVE_NOTE = 5;
